import axios from 'axios'
import {ShareholderListParams, ShareholderLookupType} from '../Model'

const API_URL = window.__RUNTIME_CONFIG__.REACT_APP_API_URL

const url = (type: ShareholderLookupType) => `${API_URL}/${type}`

export const service = {
  getRecords: ({type, ...params}: ShareholderListParams) => axios.get(url(type), {params}),

  getBatches: (type: ShareholderLookupType) =>
    axios.get(`${url(type)}/batch`, {params: {page: 1, limit: 100}}),

  importFile: (type: ShareholderLookupType, file: File, date?: string) => {
    const form = new FormData()
    form.append('file', file)
    if (date) form.append('date', date)
    return axios.post(`${url(type)}/import`, form)
  },

  getSample: (type: ShareholderLookupType) =>
    axios.get(`${url(type)}/sample`, {responseType: 'blob'}),

  setBatchStatus: (type: ShareholderLookupType, id: string, isActive: boolean) =>
    axios.patch(`${url(type)}/batch/${id}/status`, {isActive}),

  deleteBatch: (type: ShareholderLookupType, id: string) => axios.delete(`${url(type)}/batch/${id}`),
}
